import { PayloadAction, createSlice } from "@reduxjs/toolkit";
import { FocusAlertModel, FocusTaskModel } from "../../../shared/lib/types/focus-tasks-model/focus-task-model"


type FocusInitial = {
    entities: FocusTaskModel;
    alert: FocusAlertModel,
    error: string | null;
}

export const initilStateFocus: FocusInitial = {
    entities: {
        focusViewVariant: 0,
        isFocused: false,
    },
    alert: {
        priorityAlert: null,
        isOpened: false,
        messageAlert: {
            messageTitle: null,
            messageDescr : null
        }
    }, 
    error: null
}

export const focusedTaskSlice = createSlice({
    name: 'focus-task',
    initialState: initilStateFocus,
    selectors: {
        getVariantView: (state) => state.entities.focusViewVariant,
        getFocusTask: (state) => state.entities.isFocused,
        getFocusAlert: (state) => state.alert.isOpened,
        getFocusAlertMessage: (state) => state.alert.messageAlert    
    },
    reducers: {
        actionFocus: (state, action: PayloadAction<{isOpen: boolean}>) => {
            state.entities.isFocused = action.payload.isOpen
        },
        changeVariantView: (state, action: PayloadAction<{varinatView: 0 | 1}>) => {
            state.entities.focusViewVariant =  action.payload.varinatView
        },
        setPriorityAlert: (state, action: PayloadAction<{priority: 0 | 1 | 2 | 3 | null}>) => {
            state.alert.priorityAlert = action.payload.priority
        },
        activateAlert: (state, action: PayloadAction<{isOpened: boolean}>) => {
            state.alert.isOpened = action.payload.isOpened
        },
        setMessageAlert: (state, action: PayloadAction<{messageDescr: string | null, messageTitle: string | null }>) => {
            state.alert.messageAlert.messageTitle = action.payload.messageTitle
            state.alert.messageAlert.messageDescr = action.payload.messageDescr
        }
    }
})